export const CHANGE_DIAGNOSTICS_PROFILE_TYPE_TOOLTIP =
  'Enabling this option will allow other users to see this horse profile including the variant summary for diagnostic, health and coat color data. You may also share it using the link.';

export const CHANGE_ANCESTRY_PROFILE_TYPE_TOOLTIP = `Enabling this option will allow other users to see this horse's Ancestry profile. You may also share it by using the link.`;
